/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./style.css";

export default function Roadmap() {
  return (
    <div style={{ backgroundColor: "#373c3e" }} className="py-5">
      <div className="container mb-5 roadmap" id="roadmap">
        <div className="row text-center text-white mb-5">
          <div className="col-lg-8 mx-auto">
            <h1 className="tittle text-center t-shadow">Roadmap</h1>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-7 mx-auto">
            <ul
              className="timeline "
              data-aos="fade-left"
              data-aos-duration="1000"
              data-aos-once="true"
            >
              <li className="timeline-item bg-white rounded ml-3 p-4 shadow">
                <div className="timeline-arrow"></div>
                <h2 className="h5 mb-0">PHASE 1: PRE-LAUNCH</h2>
                <span className="small text-gray">
                  <i class="fas fa-clock mr-1 icon"></i>Egg stage
                </span>
                <ul style={{ paddingLeft: "15px", marginTop: "10px" }}>
                  <li>
                    <p className="text-small font-weight-bold">
                      Finalize art design
                    </p>
                  </li>
                  <li>
                    <p className="text-small font-weight-bold">
                      Finalize website
                    </p>
                  </li>
                </ul>
              </li>
              <li className="timeline-item bg-white rounded ml-3 p-4 shadow">
                <div className="timeline-arrow"></div>
                <h2 className="h5 mb-0">PHASE 2: PRE-SALE (Larva Stage)</h2>
                <span className="small text-gray">
                  <i class="fas fa-clock mr-1 icon"></i>Day 6
                </span>
                <ul style={{ paddingLeft: "15px", marginTop: "10px" }}>
                  <li>
                    <p className="text-small font-weight-bold">
                      1,000 discord (10 beez)/3,000 discord (10 beez)/4,500
                      discord (10 beez).
                    </p>
                  </li>
                  <li>
                    <p className="text-small font-weight-bold">
                      Free NFT apparel featuring your minted NFT during Phase 4.
                    </p>
                  </li>
                  <li>
                    <p className="text-small font-weight-bold">
                      1,000 bees to be minted for .5 sol w/ an exclusive Needz
                      Beez OG Minter Black Card distributed during Phase 4.
                    </p>
                  </li>
                </ul>
              </li>
              <li className="timeline-item bg-white rounded ml-3 p-4 shadow">
                <div className="timeline-arrow"></div>
                <h2 className="h5 mb-0">PHASE 3: LAUNCH 1st Mint (Larva) </h2>
                <span className="small text-gray">
                  <i class="fas fa-clock mr-1 icon"></i>Day 10
                </span>
                <ul style={{ paddingLeft: "15px", marginTop: "10px" }}>
                  <li>
                    <p className="text-small font-weight-bold">
                      50% of 1st mint (5 sol giveaway for 1 holder).
                    </p>
                  </li>
                  <li>
                    <p className="text-small font-weight-bold">
                      Merch Store Launch
                    </p>
                    <li>
                      <p className="text-small font-weight-bold">
                        100% of 1st mint- 20% ROYALTIES activated (5 sol
                        giveaway for 1 holders).
                      </p>
                    </li>
                    <li>
                      <p className="text-small font-weight-bold">
                        4 HOLDERS OF QUEEN BEE WILL GET 5 SOL A MONTH FOR 3
                        months.
                      </p>
                    </li>
                  </li>
                </ul>
              </li>
              <li className="timeline-item bg-white rounded ml-3 p-4 shadow">
                <div className="timeline-arrow"></div>
                <h2 className="h5 mb-0">PHASE 4: PRE-LAUNCH 2 (Pupa) </h2>
                <span className="small text-gray">
                  <i class="fas fa-clock mr-1 icon"></i>Day 14
                </span>
                <ul style={{ paddingLeft: "15px", marginTop: "10px" }}>
                  <li>
                    <p className="text-small font-weight-bold">
                      REVEAL BEE FARM TRIP LOCATION.
                    </p>
                  </li>
                  <li>
                    <p className="text-small font-weight-bold">
                      5 Sol giveaway for 2 holders.
                    </p>
                  </li>
                  <li>
                    <p className="text-small font-weight-bold">
                      AFTER 40 DAYS, HOLDERS WILL QUALIFY FOR BEE FARM TRIP,
                      WHITELIST FOR SECOND MINT.
                    </p>

                    <li>
                      <p className="text-small font-weight-bold">
                        COLLABORATION WITH OTHER NFT PROJECTS
                      </p>
                    </li>
                  </li>
                </ul>
              </li>
              <li className="timeline-item bg-white rounded ml-3 p-4 shadow">
                <div className="timeline-arrow"></div>
                <h2 className="h5 mb-0">PHASE 5: (Mature Pupa) </h2>
                <span className="small text-gray">
                  <i class="fas fa-clock mr-1 icon"></i>Day 21
                </span>
                <ul style={{ paddingLeft: "15px", marginTop: "10px" }}>
                  <li>
                    <p className="text-small font-weight-bold">SECOND MINT</p>
                  </li>
                  <li>
                    <p className="text-small font-weight-bold">
                      50% MINT OF SECOND MINT- Live Discord and Twitch party +
                      Merch Giveaway.
                    </p>
                    <li>
                      <p className="text-small font-weight-bold">
                        6,000 discord (10 beez)/8,500 discord (10 beez)/10,000
                        discord (10 beez).
                      </p>
                    </li>
                    <li>
                      <p className="text-small font-weight-bold">
                        100% MINT OF SECOND MINT- FORM OF COMMUNITY DAO.
                      </p>
                    </li>
                    <li>
                      <p className="text-small font-weight-bold">
                        Release of Needz Beez Token ($NBZ).
                      </p>
                    </li>
                  </li>
                </ul>
              </li>
              <li className="timeline-item bg-white rounded ml-3 p-4 shadow">
                <div className="timeline-arrow"></div>
                <h2 className="h5 mb-0">PHASE 6: (Adult)</h2>
                <span className="small text-gray">
                  <i class="fas fa-clock mr-1 icon"></i>Day 21
                </span>
                <ul style={{ paddingLeft: "15px", marginTop: "10px" }}>
                  <li>
                    <p className="text-small font-weight-bold">NFT GAME BETA</p>
                  </li>
                  <li>
                    <p className="text-small font-weight-bold">
                      Discord process of deciding how to spend Community dao.
                    </p>
                    <li>
                      <p className="text-small font-weight-bold">
                        OG Minters only exclusive Twitch release party of NFT
                        BETA Play-to-Earn game + 5 sol giveaway.
                      </p>
                    </li>
                    <li>
                      <p className="text-small font-weight-bold">
                        10 OG Minter will receive $100 in game credit.
                      </p>
                    </li>
                  </li>
                </ul>
              </li>
              <li className="timeline-item bg-white rounded ml-3 p-4 shadow">
                <div className="timeline-arrow"></div>
                <h2 className="h5 mb-0">
                  PHASE 7: METAVERSE (Pollination Exploration){" "}
                </h2>
                <span className="small text-gray">
                  <i class="fas fa-clock mr-1 icon"></i>Day 21
                </span>
                <ul style={{ paddingLeft: "15px", marginTop: "10px" }}>
                  <li>
                    <p className="text-small font-weight-bold">
                      Public Release of Needz Beez Play-to-Earn game.
                    </p>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
